module.exports = __webpack_public_path__ + "img/background.73787be6.png";